import styled from '@emotion/styled';

const ContextContainer = styled.div`
  width: 100%;
  height: 59px;

  &.Title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &.contextFirst {
    background-color: var(--light-grey);
    margin-bottom: 25px;
    font-family: 'Pretendard';
    
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    padding-top: 15px;
    padding-left: 20px;
    color: var(--dark-grey);
  }

  &.context {
    background-color: var(--light-grey);
    font-family: 'Pretendard';
    
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    padding-top: 15px;
    padding-left: 20px;
    color: var(--dark-grey);
  }

  &.small {
    width: 274px;
    font-family: 'Pretendard';
    
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    padding-top: 15px;
    padding-left: 20px;
    background-color: var(--light-grey);
    color: var(--dark-grey);
  }
`

export default ContextContainer